import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Rating } from "react-simple-star-rating";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import exportsvg from "../../assets/images/admin/dashboard/export.svg";
import { apiUrl } from "../../config/Config";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Reviews = () => {
  const navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [reviewStatus, setReviewStatus] = useState("allreviews");
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const paginationPageSizeSelector = useMemo(() => [10, 20, 50, 100], []);

  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + userdata?.token,
    },
  };

  const formatDate = (dateValue) => {
    if (!dateValue) return "NA";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return dateValue;
    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  };

  const fetchReviews = async () => {
    setLoading(true);
    await axios
      .post(apiUrl + "getadminreviews", {}, headers)
      .then((res) => {
        if (res.data.status === "success") {
          setReviews(Array.isArray(res.data.data) ? res.data.data : []);
        } else {
          Swal.fire({
            text: res.data.message,
            icon: "error",
            confirmButtonColor: "rgb(59, 151, 196)",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: err.message,
          icon: "error",
          confirmButtonColor: "rgb(59, 151, 196)",
        });
      });
    setLoading(false);
  };

  useEffect(() => {
    if (userdata && Object.keys(userdata).length > 0) {
      fetchReviews();
    } else {
      navigate("/admin/login");
    }
  }, []);

  const rowData = useMemo(() => {
    const mappedReviews = reviews.map((review) => ({
      id: review.id,
      customerId: review.customer_id,
      orderID: review.order_number || "NA",
      customerName: review.customer_name || "Customer",
      product: review.product_name || "Product",
      comment: review.comment || "NA",
      date: formatDate(review.created_at),
      status: review.status || "published",
      rating: Number(review.rating || 0),
    }));

    if (reviewStatus === "feedbacks") {
      return mappedReviews.filter((review) => review.comment && review.comment !== "NA");
    }

    return mappedReviews;
  }, [reviews, reviewStatus]);

  const colDefs = useMemo(
    () => [
      { field: "orderID", headerName: "Order", filter: true },
      {
        field: "customerName",
        headerName: "Customer",
        filter: true,
        cellRenderer: (props) => (
          <button
            className="admin-link-cell"
            onClick={() => props.data.customerId && navigate(`/admin/customer-details/${props.data.customerId}`)}
          >
            {props.data.customerName}
          </button>
        ),
      },
      { field: "product", headerName: "Product", filter: true, flex: 1.4 },
      { field: "comment", headerName: "Comment", filter: true, flex: 1.6 },
      { field: "date", headerName: "Date" },
      {
        field: "rating",
        headerName: "Rating",
        cellRenderer: (props) => (
          <div className="review_rating_div" style={{ marginTop: -3 }}>
            <Rating initialValue={props.data.rating} readonly iconsCount={5} size={17} />
          </div>
        ),
      },
      {
        field: "status",
        headerName: "Status",
        cellRenderer: (props) => (
          <div className={`orderstatusbg ${props.data.status === "hidden" ? "cancelled" : "completed"}`}>
            <p>{props.data.status}</p>
          </div>
        ),
      },
    ],
    [navigate]
  );

  return (
    <div>
      <div className="dashboardbox" style={{ width: "100%" }}>
        <div className="productstogglebar mt-2">
          <div className="orderstatustogglediv">
            {[
              ["allreviews", "All Reviews"],
              ["feedbacks", "Feedbacks"],
            ].map(([key, label]) => (
              <div
                key={key}
                className={reviewStatus === key ? "orderstatusdiv active" : "orderstatusdiv"}
                onClick={() => setReviewStatus(key)}
              >
                <p>{label}</p>
              </div>
            ))}
          </div>
          <div className="filterdiv" style={{ marginLeft: "auto" }}>
            <img src={exportsvg} className="orderexporticon" alt="" />
            <p>{loading ? "Loading..." : `${rowData.length} Reviews`}</p>
          </div>
        </div>

        <div className="ag-theme-quartz mt-4" style={{ width: "100%", height: 550 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={{ flex: 1 }}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            rowHeight={50}
          />
        </div>
      </div>
    </div>
  );
};

export default Reviews;
